import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  Classic: () => [
    import(
      './viewer/skinComps/Classic/Classic.skin' /* webpackChunkName: "LinkBar_Classic" */
    ),
  ],
  Responsive: () => [
    import(
      './viewer/skinComps/Responsive/Responsive.skin' /* webpackChunkName: "LinkBar_Responsive" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('LinkBar', UiTypes),
};

export default entry;
